module.exports = __webpack_public_path__ + "static/media/claw418_3c.ffc8fa04.svg";